//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ListItem from "~/components/list/ListItem"

export default {
	name: "parliamentarian-list",
	components: {
		ListItem
	},
	props: {
		list: {
			type: Array,
		},
		view: {
			type: String, // "list", "grid"
			default: "grid",
		},
	},
	methods: {
		showEntry(parliamentarian) {
			return this.$store.getters["filters/showEntry"](
				"parliamentarians",
				parliamentarian
			);
		},
	},
};
